import React from "react";
import styled from "@emotion/styled";

const FooterSection = styled.div`
  background-image: url(/footer_wave.svg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 250px;
  position: relative;

  span {
    position: absolute;
    bottom: 4rem;
    color: #fff;

    a {
      text-decoration: underline;
    }
  }
`;
function Footer() {
  return (
    <FooterSection>
      <div className="footer-container">
        <p>
          Have any questions about my projects or just want to chat? Feel free to reach out. I'll try my best to reply ASAP.
        </p>
        <div className="footer-social-icons">

        </div>
      </div>
    </FooterSection>
  );
}

export default Footer;
